import { IResourceCostType } from "../../../@types/resource-cost.type"
import { getErrorMessage } from "../../../utils/utils"
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"

export const getAllResourceCostByResourceId = async (resourceId: string) => {
    try {
        const { data } = await Api.get(`api/ResourceCost/GetAllResourceCostByResourceId?resourseId=${resourceId}`)
        return data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os resourcesCost'))
    }
}

export const deleteResourceCostById = async (resourceCostId: string) => {
    try {
        const { data } = await Api.delete(`api/ResourceCost/DeleteResourceCostById/${resourceCostId}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar ResourceCost'))
    }
    
}

export const updateResourceCost = async (resourceCostDto: IResourceCostType) => { 
    try {
        const { data } = await Api.put(`api/ResourceCost/UpdateResourceCost`, resourceCostDto)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao atualizar o ResourceCost'))
    }
}
